module.exports = __webpack_public_path__ + "media/images/form-bg-a02f1696acf54f8f35aaad30088f1078.png";